<template>
  <div class="bi-filter width-responsiveness">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="bi-filter__form"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
          style="gap: 12px 0; justify-content: space-between; align-items: center"
        >
          <md-layout
            md-flex="50"
            md-flex-medium="100"
          >
            <BIPeriodSelect v-model="selectedMonth" />
          </md-layout>

          <md-layout
            md-flex="20"
            md-flex-medium="100"
            class="box-action"
          >
            <md-button
              class="btn btn-primary btn-regular-size btn-export"
              style="height: revert-rule"
              @click="$emit('exportar', selectedPeriod)"
            >
              <md-icon md-src="/static/images/icon-download-arrow.svg" />
              Exportar Relatório
            </md-button>
          </md-layout>
        </md-layout>

        <DynamicTabs
          :tabs="tabs"
          :active-tab="activeTabIndex"
          class="bi-filter__tabs"
          @update:activeTab="$emit('tab-change', $event)"
        />
      </div>
    </card-form>
  </div>
</template>

<script>
import moment from 'moment'
import CardForm from '@/components/common/CardForm'
import DynamicTabs from '@/components/common/DynamicTabs'
import SvgLoader from '@/components/common/SvgLoader'
import BIPeriodSelect from './BIPeriodSelect.vue'

export default {
  name: 'BIFilter',
  components: { CardForm, DynamicTabs, SvgLoader, BIPeriodSelect },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedMonth: moment().format('YYYY-MM'),
      selectedPeriod: null,
    }
  },
  watch: {
    selectedMonth(val) {
      this.$emit('period-change', val)
    },
  },
  mounted() {
    this.$emit('period-change', this.selectedMonth)
  },
  methods: {
    onMonthChange() {},
  },
}
</script>

<style lang="scss">
.bi-filter {
  margin-top: 25px;
  font-family: 'Exo 2', sans-serif !important;

  .card-form__container {
    border-radius: 8px;
    padding-bottom: 12px;
  }

  &__month-wrap {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  &__month-label {
    font-size: 11px;
    color: #999;
    font-family: 'Exo 2', sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  &__month-input {
    height: 36px;
    border: none;
    border-bottom: 1px solid #ccc;
    background: transparent;
    font-size: 14px;
    font-family: 'Exo 2', sans-serif;
    color: #333;
    outline: none;
    width: 100%;
    padding: 0 2px;
    cursor: pointer;

    &:focus {
      border-bottom-color: #7b1a54;
    }
  }

  &__tabs {
    margin-top: 28px;
    margin-bottom: 0;

    .dynamic-tab__title--active {
      background-color: #fff;
    }
  }

  .box-action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: 0;
  }

  .btn-search {
    width: 100%;
    max-width: 180px;
    text-transform: uppercase;
    font-family: 'Exo 2', sans-serif !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    font-size: 14px;
    gap: 4px;

    .md-icon {
      margin: 0;
    }
  }

  .btn-export {
    font-size: 14px;
    padding: 0 24px;

    .md-icon {
      margin: 0;
      width: 32px;
      min-width: 32px;
      height: 32px;
      min-height: 32px;
      font-size: 32px;
    }
  }
}
</style>
